var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canReadInspection || _vm.isTenant
    ? _c("Provider", [
        _c(
          "div",
          { staticClass: "inspection" },
          [
            _c(
              "Collapse",
              {
                staticClass: "inspection__collaspe",
                attrs: { title: _vm.$t("tenantProjects.inspection.title") },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "inspection__collaspe-content",
                    attrs: { slot: "content" },
                    slot: "content",
                  },
                  [
                    _c("HKLTable", {
                      staticClass: "inspection__table",
                      attrs: {
                        dataSource: _vm.orderedItems,
                        columns: _vm.columns,
                      },
                    }),
                    _vm._v(" "),
                    _vm.canUpdateInspection
                      ? _c(
                          "HKLButton",
                          {
                            staticClass: "inspection__create-btn",
                            attrs: { color: "darkblue" },
                            on: { click: _vm.openNewInspectionModal },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "tenantProjects.inspection.createButton"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("EditInspectionModal", { ref: "editPopup" }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }